<template>
    <ui-modal icon="far fa-cog" name="modal-sales-table-new" title="Tabelas de Vendas" size="xs">
        <div class="modal-content-line">
            <h3>Você deseja criar uma nova tabela ou clonar de uma existente?</h3>
        </div>
		
        <template #footer>
            <ui-button design="primary md" @click="add">Nova</ui-button>
            <ui-button design="success md" @click="openModalClone">Clonar</ui-button>
            <ui-button design="danger md" @click="close">Cancelar</ui-button>
        </template>
    </ui-modal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiModal } from '@/components/ui/modal'

	export default {
		name:"modal-sales-table-new",
		components: {
			uiButton,
			uiModal,
		},

		props: {},

		data() {
			return {
				tables: [],
			}
		},

		methods: {
			/**
			 * Emit event to add a new empty table
			 */
			add() {
				this.$root.$emit('add-new-empty-sales-table')
			},

			/**
			 * Clone the selected table
			 */
			openModalClone() {
				this.close()
				this.$root.$emit('modal-open-modal-sales-table-clone')
			},

			/**
			 * Hides the current mode
			 */
			close() {
				this.$root.$emit('modal-close-modal-sales-table-new')
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
